import React, { useCallback, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { get_dc_pdf, get_order_detail } from "../../utils/api";
import {
  Button,
  Card,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  SimpleGrid,
  Stack,
  Text,
  useDisclosure,
  Spinner,
  Checkbox,
  Box,
  Image,
  HStack,
  Divider,
  Badge,
  VStack,
  useColorModeValue,
} from "@chakra-ui/react";
import CustomButton from "../../components/ButtonComp";
import { BiArrowBack } from "react-icons/bi";
import { MdReceipt, MdLocalShipping, MdPayment, MdDescription } from "react-icons/md";
import { FiUser, FiCalendar, FiClock, FiMapPin } from "react-icons/fi";
import DisplayData from "../../components/DisplayData";
import Loader from "../../components/Loader";
import ImageModal from "../../components/ImageModal";
import { baseUrl, formatCurrency } from "../../utils/utils";
import { toast } from "react-toastify";
import CustomDataCard from "../../components/CustomDataCard";
import { get_vehicle_list } from "../../redux/vehiclSlice";
import store from "../../redux/store";
import { useSelector, useDispatch } from "react-redux";
import { get_driver_list } from "../../redux/driverSlice";
import { get_dp_list } from "../../redux/dplistSlice";
import { get_dp_vehicle_list, get_vehicle_driver_list, get_all_drivers } from "../../redux/orderSlice";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DetailProductCard from "./DetailProductCard";
import { useOrderCalculations } from "./useOrderCalculations";
import { createCustomerCardData } from "./customerProductDetail";
import GasCylinderLoader from "../../components/GasCylinderLoader";

const OrderDetail = () => {
  const dispatch = useDispatch();
  const [isImageOpen, setIsImageOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const orderData = location.state?.orderData ||
    JSON.parse(localStorage.getItem("lastOrderData")) || {};
  const [expanded, setExpanded] = useState(false);


  const savedOrderData = JSON.parse(localStorage.getItem("lastOrderData") || {});
  const {
    id = "",
    orderid = "",
    type = "1",
    returnTo = "/orders",
    returnType = "1",
    returnPage = 1,
    returnRows = 5
  } = orderData;

  const order = orderid;
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const { onClose, isOpen } = useDisclosure();

  const {
    onOpen: onOpenAsign,
    onClose: onCloseAsign,
    isOpen: isOpenAsign,
  } = useDisclosure();
  const [url, setUrl] = useState("");
  const [settingData, setSettingData] = useState({});
  const [selectedProducts, setSelectedProducts] = useState([]);

  const { dp_vehicle_list, vehicle_driver_list, vehicle_loading, driver_loading } = useSelector((state) => state.orders);
  const { dp_list } = useSelector((state) => state.dplist);

  const user = JSON.parse(localStorage.getItem("authToken1"));
  const { grandTotal, unassignedProducts, paymentSlips, getCustomerCardData } = useOrderCalculations(data, type);

  const [udpateAsingData, setUdpateAsingData] = useState({});
  const [isPoDocumentOpen, setIsPoDocumentOpen] = useState(false);
  const [poDocumentUrl, setPoDocumentUrl] = useState("");

  // Color mode values for consistent theming
  const cardBg = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const textColor = useColorModeValue("gray.600", "gray.300");
  const headingColor = useColorModeValue("gray.800", "white");
  const successCardBg = useColorModeValue("green.50", "green.900");
  const infoCardBg = useColorModeValue("blue.50", "blue.900");
  const warningCardBg = useColorModeValue("orange.50", "orange.900");

  useEffect(() => {
    if (udpateAsingData.dplist) {
      dispatch(get_dp_vehicle_list(udpateAsingData.dplist));
      setUdpateAsingData(prev => ({
        ...prev,
        vehicle: "",
        driver: ""
      }));
    }
  }, [udpateAsingData.dplist, dispatch]);

  useEffect(() => {
    if (udpateAsingData.vehicle) {
      console.log("Fetching drivers for vehicle:", udpateAsingData.vehicle);
      dispatch(get_vehicle_driver_list(udpateAsingData.vehicle));
      setUdpateAsingData(prev => ({
        ...prev,
        driver: ""
      }));
    }
  }, [udpateAsingData.vehicle, dispatch]);

  useEffect(() => {
    store.dispatch(get_vehicle_list());
    store.dispatch(get_driver_list());
    store.dispatch(get_dp_list({ page: 1, rows: 100, }));
    dispatch(get_all_drivers());
  }, [dispatch]);

  useEffect(() => {
    if (data?.details) {
      const unassignedProducts = data.details
        .filter(product => product.orderstatus == 1)
        .map(product => product.id);
      setSelectedProducts(unassignedProducts);
    }
  }, [data?.details]);

  const fetchOrderDetails = useCallback(async () => {
    try {
      setLoading(true);
      const el = await get_order_detail(id, orderid, type, setLoading);
      if (el?.success) {
        setData(el.reponselist);
        setSettingData(prev => ({
          ...prev,
          credit_days: el.reponselist.credit_days,
          credit_limit: el.reponselist.credit_limit,
        }));
      }
    } catch (error) {
      console.error("Error fetching order details:", error);
      toast.error("Failed to fetch order details");
    } finally {
      setLoading(false);
    }
  }, [id, orderid, type]);

  useEffect(() => {
    if (!orderid) {
      console.error("No orderid available");
      toast.error("Order information not found");
      navigate(returnTo);
      return;
    }

    if (!id) {
      console.warn("No id available, proceeding with just orderid");
    }

    fetchOrderDetails();
  }, [id, orderid, fetchOrderDetails]);

  const HandleAsign = async () => {
    const error = validateAsign();
    if (Object.keys(error).length === 0) {
      setLoading(true);
      const body = new FormData();

      body.append("action", "assign_order");
      body.append("orderid", data.orderid);
      body.append("driver_id", udpateAsingData.driver);
      body.append("dpid", udpateAsingData.dplist);
      body.append("vehicle_id", udpateAsingData.vehicle);
      body.append("userid", data.userid);
      body.append("modified_by", user?.id);

      if (data?.scheduletime) {
        body.append("scheduletime", data.scheduletime);
      }

      selectedProducts.forEach(id => {
        body.append("id[]", id);
      });

      try {
        const response = await fetch(baseUrl + "orders.php", {
          method: "POST",
          body: body,
        });
        const res = await response.json();

        if (res.success) {
          toast.success(res.message || "Order assigned successfully");
          fetchOrderDetails();
          setUdpateAsingData({});
          onCloseAsign();
          navigate("/orders", {
            state: {
              returnType: "2",
              returnPage: 1,
              returnRows: 5
            }
          });

        } else {
          toast.error(res.message || "Order assignment failed");
        }
      } catch (err) {
        toast.error("Network error occurred while assigning order");
        console.error(err);
      } finally {
        setLoading(false);
      }
    } else {
      setUdpateAsingData({ ...udpateAsingData, ...error });
    }
  };

  const validateAsign = () => {
    const error = {};

    if (!udpateAsingData?.dplist) {
      error.dplist_error = "Please select delivery partner";
    }
    if (!udpateAsingData?.vehicle) {
      error.vehicle_error = "Please select vehicle";
    }
    if (!udpateAsingData?.driver) {
      error.driver_error = "Please select driver";
    }
    if (selectedProducts.length === 0) {
      error.products_error = "Please select at least one product";
    }

    return error;
  };

  const handleProductSelection = (productId, isChecked) => {
    if (isChecked) {
      setSelectedProducts([...selectedProducts, productId]);
    } else {
      setSelectedProducts(selectedProducts.filter(id => id !== productId));
    }
  };

  const downloadDCPdf = async (userid, orderid, details_id, dc_no) => {
    try {
      const blob = await get_dc_pdf({ userid, orderid, details_id, dc_no });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${dc_no}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error("Failed to download DC PDF:", error);
    }
  };

  const downloadInvoicePDF = async () => {
    try {
      if (!data || !data.details) {
        throw new Error("Order data not available");
      }

      const allProductsEligible = data.details.every(product => {
        const orderedQty = parseInt(product.count) || 0;
        const deliveredQty = parseInt(product.delivered_quantity) || 0;
        const cancelledQty = parseInt(product.cancelled_quantity) || 0;
        return orderedQty === (deliveredQty + cancelledQty);
      });

      if (!allProductsEligible) {
        throw new Error("Invoice is only available for fully delivered or cancelled orders");
      }

      const response = await fetch(
        `
https://gaswale.vensframe.com/api/customer/orderpdf.php?orderid=${data?.orderid}&userid=${data?.userid}`
      );

      if (!response.ok) throw new Error("Failed to fetch PDF");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `Invoice_${data?.orderid}.pdf`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);

      toast.success("Invoice download started. Check your downloads folder.");
    } catch (error) {
      console.error("Invoice download failed:", error);
      toast.error(error.message || "Failed to download invoice. Please try again.");
    }
  };

  const getFileType = (url) => {
    if (!url) return null;
    const extension = url.toLowerCase().split('.').pop();
    return extension;
  };

  const handlePoDocumentClick = async (event, documentUrl) => {
    event.preventDefault();
    const fileType = getFileType(documentUrl);

    if (fileType === 'pdf') {
      try {
        const response = await fetch(documentUrl, { mode: 'cors' });
        if (!response.ok) throw new Error(`HTTP error: ${response.status}`);

        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = `PO_Document.${fileType}`;
        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(blobUrl);
      } catch (error) {
        console.error('PDF download failed:', error);
        window.open(documentUrl, '_blank');
      }
    } else if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(fileType)) {
      setPoDocumentUrl(documentUrl);
      setIsPoDocumentOpen(true);
    } else {
      window.open(documentUrl, '_blank');
    }
  };



  const handleBack = () => {
    if (returnTo && returnType) {
      navigate(returnTo, {
        state: {
          returnType,
          returnPage,
          returnRows,
        },
      });
    } else {
      navigate(-1);
    }
  };

  const totalOrderAmount = data?.details?.reduce((acc, item) => {
    const cardData = createCustomerCardData(item, type, data.payment_mode);
    return acc + (cardData?.calculatedTotal || 0);
  }, 0) || 0;

  // Calculate totals for order summary
  const calculateOrderSummary = () => {
    let subtotal = 0;
    let totalGST = 0;
    let totalDiscount = 0;

    data?.details?.forEach(item => {
      const cardData = getCustomerCardData(item);
      const itemPrice = parseFloat(item.price) || 0;
      const quantity = parseInt(item.count) || 0;
      const gst = parseFloat(item.gst) || 0;

      const basePrice = itemPrice * quantity;
      subtotal += basePrice;
      totalGST += (basePrice * gst) / 100;

      if (cardData?.discount) {
        totalDiscount += parseFloat(cardData.discount) || 0;
      }
    });

    return { subtotal, totalGST, totalDiscount };
  };

  const { subtotal, totalGST, totalDiscount } = calculateOrderSummary();

  const getStatusBadge = (orderType) => {
    const statusConfig = {
      "1": { color: "blue", label: "New" },
      "2": { color: "orange", label: "Assigned" },
      "3": { color: "purple", label: "In Progress" },
      "4": { color: "green", label: "Completed" },
      "5": { color: "red", label: "Cancelled" },
      "6": { color: "yellow", label: "Rescheduled" }
    };

    const config = statusConfig[orderType] || { color: "gray", label: "Unknown" };
    return <Badge colorScheme={config.color} fontSize="xs" px={2} py={1} borderRadius="full">{config.label}</Badge>;
  };

  const isInvoiceAvailable =
  data?.details?.every(item => {
    const orderedQty = parseInt(item.count) || 0;
    const deliveredQty = parseInt(item.delivered_quantity) || 0;
    const cancelledQty = parseInt(item.cancelled_quantity) || 0;
    return orderedQty === (deliveredQty + cancelledQty);
  });


  return (
    <>
      {/* Enhanced Header */}
      <Card
        bg={cardBg}
        border="1px solid"
        borderColor={borderColor}
        display="flex"
        flexDirection="row"
        alignItems="center"
        justify="space-between"
        paddingInline={6}
        paddingBlock={4}
        mb={6}
        borderRadius="xl"
        boxShadow="sm"
      >
        <Flex align="center" gap={4}>
          <Box>
            <Heading fontSize="2xl" color={headingColor} fontWeight="bold">
              Order Details
            </Heading>
            <Text fontSize="sm" color={textColor} mt={1}>
              Order ID: {data.orderid || "Loading..."}
            </Text>
          </Box>
          {getStatusBadge(type)}
        </Flex>
        <Flex alignItems="center" gap={3}>
          <CustomButton
            icon={<BiArrowBack color="#fff" />}
            title="Back to Orders"
            height="40px"
            b_color="#2D3748"
            onClick={handleBack}
            px={4}
          />
        </Flex>
      </Card>

      {loading ? (
        <GasCylinderLoader size="sm" loadingText="Loading order details" />
      ) : (
        <VStack spacing={6} align="stretch">
          {/* Row 1: Order Information and Order Summary */}
          <SimpleGrid columns={[1, 1, 2]} spacing={6}>
            {/* Order Information Card */}
            <Card
              p={6}
              borderRadius="xl"
              boxShadow="sm"
              bg={cardBg}
              border="1px solid"
              borderColor={borderColor}
            >
              <Flex align="center" mb={5} pb={4} borderBottom="2px solid" borderColor={borderColor}>
                <Box fontSize="xl" color="blue.500" mr={3}>
                  <FiUser />
                </Box>
                <Heading fontSize="lg" color={headingColor} fontWeight="semibold">
                  Order Information
                </Heading>
              </Flex>

              <Stack spacing={4}>
                <InfoRow
                  label="Order ID"
                  value={data.orderid || "NA"}
                  valueColor="orange.500"
                  valueFontWeight="bold"
                  icon="📋"
                />
                <InfoRow
                  label="Customer Name"
                  value={data.customer_name || "NA"}
                  valueColor="green.600"
                  valueFontWeight="bold"
                  icon="👤"
                />
                <InfoRow
                  label="Mobile Number"
                  value={data.mobile || "NA"}
                  icon="📱"
                />
                <InfoRow
                  label="Email ID"
                  value={data.email || "NA"}
                  icon="📧"
                />
                <InfoRow
                  label="Payment Mode"
                  value={data.paymentmode || "NA"}
                  icon="💳"
                />

                {data.wallet_amount !== "0.00" && (
                  <InfoRow
                    label="Wallet Amount"
                    value={formatCurrency(data.wallet_amount)}
                    icon="💰"
                  />
                )}

                <InfoRow
                  label="Security Deposit"
                  value={formatCurrency(
                    data?.details?.reduce((acc, item) => {
                      const cardData = getCustomerCardData(item);
                      return acc + (cardData?.totalSecurityDeposit || 0);
                    }, 0) || 0
                  )}
                  icon="🛡️"
                />

                <Box pt={3} borderTop="1px solid" borderColor={borderColor}>
                  <Flex align="center" mb={2}>
                    <Box fontSize="sm" color="blue.500" mr={2}>
                      <FiMapPin />
                    </Box>
                    <Text fontSize="sm" color={textColor} fontWeight="medium">Shipping Address</Text>
                  </Flex>
                  <Text fontSize="sm" fontWeight="medium" pl={6}>{data.shipping_address || "NA"}</Text>
                </Box>

                {/* PO Details */}
                {data.paymentmode !== "COD" && data.paymentmode !== "ONLINE" && (
                  <Box pt={3} borderTop="1px solid" borderColor={borderColor}>
                    <Text fontSize="md" color={headingColor} fontWeight="semibold" mb={3}>PO Details</Text>
                    <Stack spacing={3} pl={2}>
                      {data?.paymentid && (
                        <InfoRow label="PO Number" value={data.paymentid} />
                      )}
                      {data?.po_date && data.po_date !== "0000-00-00 00:00:00" && (
                        <InfoRow
                          label="PO Date"
                          value={new Date(data.po_date).toLocaleString("en-IN", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true
                          })}
                          icon="📅"
                        />
                      )}

                      {data?.paymentmode === "PO" && (
                        <>
                          {data?.quotation_number && (
                            <InfoRow label="Quotation Number" value={data.quotation_number} />
                          )}
                          {data?.quotation_date && data.quotation_date !== "0000-00-00 00:00:00" && (
                            <InfoRow
                              label="Quotation Date"
                              value={new Date(data.quotation_date).toLocaleString("en-IN", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true
                              })}
                            />
                          )}
                        </>
                      )}
                    </Stack>
                  </Box>
                )}

                {data.paymentmode !== "COD" && data.paymentmode !== "ONLINE" && (
                  <Box pt={3} borderTop="1px solid" borderColor={borderColor}>
                    <Text fontSize="md" color={headingColor} fontWeight="semibold" mb={3}>
                      Uploaded PO Details
                    </Text>
                    <Stack spacing={3} pl={2}>
                      <InfoRow label="PO Number" value={data.user_po_number ? data.user_po_number : "NA"} />

                      <InfoRow
                        label="PO Date"
                        value={
                          data?.podate
                            ? new Date(data.podate).toLocaleString("en-IN", {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            })
                            : "NA"
                        }
                        icon="📅"
                      />

                      {data?.po_document && data.po_document !== "null" && data.po_document !== "undefined" && (
                        <Flex justify="space-between" align="center" bg="blue.50" p={3} borderRadius="md">
                          <Flex align="center">
                            <Box fontSize="lg" mr={2}>
                              <MdDescription />
                            </Box>
                            <Text fontSize="sm" color="gray.600">PO Document</Text>
                          </Flex>
                          <Button
                            size="sm"
                            colorScheme="blue"
                            variant="outline"
                            onClick={(e) => handlePoDocumentClick(e, data.po_document)}
                          >
                            {getFileType(data.po_document) === 'pdf' ? 'View PDF' : 'View Document'}
                          </Button>
                        </Flex>
                      )}

                      {data?.paymentmode === "PO" && (
                        <>
                          {data?.uploaded_quotation_number && (
                            <InfoRow label="Quotation Number" value={data.uploaded_quotation_number} />
                          )}
                          {data?.uploaded_quotation_date && data.uploaded_quotation_date !== "0000-00-00 00:00:00" && (
                            <InfoRow
                              label="Quotation Date"
                              value={new Date(data.uploaded_quotation_date).toLocaleString("en-IN", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                              })}
                            />
                          )}
                        </>
                      )}
                    </Stack>
                  </Box>
                )}

                {/* Date Information */}
                <Box pt={3} borderTop="1px solid" borderColor={borderColor}>
                  <Text fontSize="md" color={headingColor} fontWeight="semibold" mb={3}>Timeline</Text>
                  <Stack spacing={3} pl={2}>
                    {data.assign_datetime && data.assign_datetime !== "0000-00-00 00:00:00" && (
                      <InfoRow
                        label="Initiated Date & Time"
                        value={new Date(data.assign_datetime).toLocaleString("en-IN", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })}
                        icon="🚀"
                      />
                    )}

                    {data.deliver_datetime && data.deliver_datetime !== "0000-00-00 00:00:00" && (
                      <InfoRow
                        label="Deliver Date & Time"
                        value={new Date(data.deliver_datetime).toLocaleString("en-IN", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })}
                        icon="✅"
                      />
                    )}
                  </Stack>
                </Box>

                {/* Reschedule Information */}
                {type === "6" && Array.isArray(data.reschecdule_orders) && data.reschecdule_orders.length > 0 && (
                  <Box pt={3} borderTop="1px solid" borderColor={borderColor}>
                    <Text fontSize="md" color={headingColor} fontWeight="semibold" mb={3}>Reschedule Details</Text>
                    {data.reschecdule_orders.map((item, index) => (
                      <Box
                        key={item.id || index}
                        mb={4}
                        p={3}
                        bg={warningCardBg}
                        borderRadius="md"
                        borderLeft="4px solid"
                        borderColor="orange.400"
                      >
                        <Text fontSize="sm" fontWeight="bold" color="orange.600" mb={2}>
                          Reschedule {data.reschecdule_orders.length > 1 ? `${index + 1}` : ''}
                        </Text>
                        <Stack spacing={2} pl={2}>
                          <InfoRow label="Notes" value={item.reschedule_notes || "NA"} fontSize="sm" />
                          <InfoRow label="Date" value={item.rescheduledate || "NA"} fontSize="sm" />
                          <InfoRow label="Time" value={item.rescheduletime || "NA"} fontSize="sm" />
                          {item.reschedule_reason && (
                            <InfoRow label="Reason" value={item.reschedule_reason} fontSize="sm" />
                          )}
                        </Stack>
                      </Box>
                    ))}
                  </Box>
                )}

                {/* Cancellation Info */}
                {type === "5" && (
                  <Box pt={3} borderTop="1px solid" borderColor={borderColor}>
                    <Text fontSize="md" color={headingColor} fontWeight="semibold" mb={3}>Cancellation Details</Text>
                    <Box p={3} bg="red.50" borderRadius="md" borderLeft="4px solid" borderColor="red.400">
                      <Stack spacing={3}>
                        {data?.cancel_reason && (
                          <InfoRow label="Cancelled Reason" value={data.cancel_reason} />
                        )}
                        {data?.cancel_explaination && (
                          <InfoRow label="Cancelled Explanation" value={data.cancel_explaination} />
                        )}
                        {data.customer_contact_attempt && (
                          <InfoRow label="Customer Contact" value={data.customer_contact_attempt} />
                        )}
                      </Stack>
                    </Box>
                  </Box>
                )}
              </Stack>

              {(unassignedProducts.length > 0 || type === "6") && (
                <Button
                  size="md"
                  colorScheme="blue"
                  w="full"
                  mt={6}
                  onClick={() => onOpenAsign()}
                  leftIcon={<MdLocalShipping />}
                  height="48px"
                  fontSize="md"
                >
                  Assign Delivery Partner
                </Button>
              )}
            </Card>

            {/* Order Summary Card */}
            <Card
              p={6}
              borderRadius="xl"
              boxShadow="sm"
              bg={cardBg}
              border="1px solid"
              borderColor={borderColor}
            >
              <Flex align="center" mb={5} pb={4} borderBottom="2px solid" borderColor={borderColor}>
                <Box fontSize="xl" color="green.500" mr={3}>
                  <MdReceipt />
                </Box>
                <Heading fontSize="lg" color={headingColor} fontWeight="semibold">
                  Order Summary
                </Heading>
              </Flex>

              <Stack spacing={4}>
                <Divider borderColor="gray.300" />

                <Box
                  bg="linear-gradient(135deg, #3182CE 0%, #2C5AA0 100%)"
                  p={5}
                  borderRadius="xl"
                  boxShadow="md"
                >
                  <Flex justify="space-between" align="center">
                    <Text fontSize="lg" color="white" fontWeight="bold">Grand Total</Text>
                    <Text fontSize="2xl" color="white" fontWeight="bold">{formatCurrency(grandTotal)}</Text>
                  </Flex>
                  <Text fontSize="xs" color="whiteAlpha.800" mt={2}>
                    Includes all taxes and charges
                  </Text>
                </Box>

                {type === "4" && (
                  <Box bg="green.50" p={4} borderRadius="lg" textAlign="center" border="1px solid" borderColor="green.200">
                    <Flex align="center" justify="center" mb={2}>
                      <Box fontSize="lg" color="green.600" mr={2}>✓</Box>
                      <Text fontSize="sm" color="green.700" fontWeight="bold">
                        Payment Received Successfully
                      </Text>
                    </Flex>
                    <Text fontSize="xs" color="green.600">
                      Order completed and payment processed
                    </Text>
                  </Box>
                )}
              </Stack>
            </Card>
          </SimpleGrid>

          {/* Row 2: Payment Information */}
          {(data.paymentmode === "ONLINE" || (type === "4" && data?.details?.some(item => 
            (item.cash_received !== "0.00" && item.cash_received !== "0") || 
            (item.online_received !== "0.00" && item.online_received !== "0")
          ))) && (
            <Box>
              <Flex align="center" mb={4}>
                <Box fontSize="xl" color="green.500" mr={3}>
                  <MdPayment />
                </Box>
                <Heading fontSize="lg" color={headingColor} fontWeight="semibold">
                  Payment Information
                </Heading>
              </Flex>

              <SimpleGrid columns={[1, 1, 2, 3]} spacing={4}>
                {/* Online Payment Card - Initial Payment */}
                {data.paymentmode === "ONLINE" && (
                  <Card
                    bg="linear-gradient(135deg, #10b981 0%, #059669 100%)"
                    color="white"
                    p={6}
                    borderRadius="xl"
                    boxShadow="lg"
                  >
                    <Flex justify="space-between" align="flex-start" mb={4}>
                      <Box>
                        <Flex align="center" gap={3} mb={2}>
                          <Box fontSize="2xl">💳</Box>
                          <Heading fontSize="lg" fontWeight="bold">Online Payment</Heading>
                        </Flex>
                        <Text fontSize="sm" opacity="0.9">Payment processed successfully</Text>
                      </Box>
                      <Box fontSize="3xl" opacity="0.8">✓</Box>
                    </Flex>

                    {data?.online_amount && data.online_amount !== "0.00" && data.online_amount !== "0" && (
                      <Text fontSize="3xl" fontWeight="bold" mb={4} textAlign="center">
                        {formatCurrency(data.online_amount)}
                      </Text>
                    )}

                    <Divider borderColor="whiteAlpha.300" my={4} />

                    <Stack spacing={3} fontSize="sm">
                      {data?.merchant_txn_no && (
                        <Flex justify="space-between" bg="whiteAlpha.200" p={2} borderRadius="md">
                          <Text opacity="0.9">Merchant Txn No:</Text>
                          <Text fontWeight="semibold">{data.merchant_txn_no}</Text>
                        </Flex>
                      )}
                      {data?.pay_status && (
                        <Flex justify="space-between" bg="whiteAlpha.200" p={2} borderRadius="md">
                          <Text opacity="0.9">Payment Status:</Text>
                          <Text fontWeight="semibold">{data.pay_status}</Text>
                        </Flex>
                      )}
                    </Stack>
                  </Card>
                )}

                {/* Payment Received Cards - Type 4 */}
                {type === "4" && data?.details?.length > 0 && data.details.map((item, idx) => {
                  const hasCash = item.cash_received !== "0.00" && item.cash_received !== "0";
                  const hasOnline = item.online_received !== "0.00" && item.online_received !== "0";

                  return (
                    <React.Fragment key={idx}>
                      {hasCash && (
                        <Card
                          bg="linear-gradient(135deg, #10b981 0%, #059669 100%)"
                          color="white"
                          p={5}
                          borderRadius="xl"
                          boxShadow="md"
                        >
                          <Flex align="center" mb={3}>
                            <Box fontSize="2xl" mr={3}>💵</Box>
                            <Heading fontSize="md">Cash Received</Heading>
                          </Flex>

                          <Text fontSize="3xl" fontWeight="bold" mb={4} textAlign="center">
                            {formatCurrency(item.cash_received)}
                          </Text>

                          <Divider borderColor="whiteAlpha.300" my={3} />

                          <Stack spacing={2} fontSize="sm">
                            <Flex justify="space-between" bg="whiteAlpha.200" p={2} borderRadius="md">
                              <Text opacity="0.9">Product:</Text>
                              <Text fontWeight="semibold">{item.product_name}</Text>
                            </Flex>
                            <Flex justify="space-between" bg="whiteAlpha.200" p={2} borderRadius="md">
                              <Text opacity="0.9">Delivery Partner:</Text>
                              <Text fontWeight="semibold">{item.delivery_partner_name || "N/A"}</Text>
                            </Flex>
                            <Flex justify="space-between" bg="whiteAlpha.200" p={2} borderRadius="md">
                              <Text opacity="0.9">Payment Time:</Text>
                              <Text fontWeight="semibold" fontSize="xs">{item.deliver_datetime || "Not Available"}</Text>
                            </Flex>
                          </Stack>
                        </Card>
                      )}

                      {hasOnline && (
                        <Card
                          bg="linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)"
                          color="white"
                          p={5}
                          borderRadius="xl"
                          boxShadow="md"
                        >
                          <Flex align="center" mb={3}>
                            <Box fontSize="2xl" mr={3}>🏦</Box>
                            <Heading fontSize="md">Online Received</Heading>
                          </Flex>

                          <Text fontSize="3xl" fontWeight="bold" mb={4} textAlign="center">
                            {formatCurrency(item.online_received)}
                          </Text>
                          <Divider borderColor="whiteAlpha.300" my={3} />

                          <Stack spacing={2} fontSize="sm">
                            <Flex justify="space-between" bg="whiteAlpha.200" p={2} borderRadius="md">
                              <Text opacity="0.9">Product:</Text>
                              <Text fontWeight="semibold">{item.product_name}</Text>
                            </Flex>
                            <Flex justify="space-between" bg="whiteAlpha.200" p={2} borderRadius="md">
                              <Text opacity="0.9">Transaction no:</Text>
                              <Text fontWeight="semibold">{item.transaction_no || "NA"}</Text>
                            </Flex>
                            <Flex justify="space-between" bg="whiteAlpha.200" p={2} borderRadius="md">
                              <Text opacity="0.9">Transaction mode:</Text>
                              <Text fontWeight="semibold">{item.transactionmode || "NA"}</Text>
                            </Flex>
                            <Flex justify="space-between" bg="whiteAlpha.200" p={2} borderRadius="md">
                              <Text opacity="0.9">Delivery Partner:</Text>
                              <Text fontWeight="semibold">{item.delivery_partner_name || "N/A"}</Text>
                            </Flex>
                            <Flex justify="space-between" bg="whiteAlpha.200" p={2} borderRadius="md">
                              <Text opacity="0.9">Payment Time:</Text>
                              <Text fontWeight="semibold" fontSize="xs">{item.deliver_datetime || "Not Available"}</Text>
                            </Flex>
                          </Stack>

                          {item.payment_slip && (
                            <Button
                              size="sm"
                              colorScheme="whiteAlpha"
                              w="full"
                              mt={3}
                              onClick={() => {
                                setSelectedImage(item.payment_slip);
                                setIsImageOpen(true);
                              }}
                              leftIcon={<MdDescription />}
                            >
                              View Payment Slip
                            </Button>
                          )}
                        </Card>
                      )}
                    </React.Fragment>
                  );
                })}
              </SimpleGrid>
            </Box>
          )}

          {/* Row 3: Scheduled Delivery */}
          {/* {data?.scheduletime && (
            <Card
              bg={warningCardBg}
              borderLeft="4px solid"
              borderColor="orange.400"
              p={5}
              borderRadius="xl"
            >
              <Flex align="center" mb={3}>
                <Box fontSize="2xl" color="orange.500" mr={3}>
                  <MdLocalShipping />
                </Box>
                <Heading fontSize="md" color="orange.700">Scheduled Delivery</Heading>
              </Flex>

              <SimpleGrid columns={[1, 2, 4]} spacing={3}>
                {data?.scheduledate && (
                  <Flex justify="space-between" align="center" bg="whiteAlpha.500" p={2} borderRadius="md">
                    <Flex align="center">
                      <Box fontSize="sm" color="orange.500" mr={2}>
                        <FiCalendar />
                      </Box>
                      <Text fontSize="sm" color="gray.600">Date:</Text>
                    </Flex>
                    <Text fontSize="sm" fontWeight="semibold">{data.scheduledate}</Text>
                  </Flex>
                )}
                <Flex justify="space-between" align="center" bg="whiteAlpha.500" p={2} borderRadius="md">
                  <Flex align="center">
                    <Box fontSize="sm" color="orange.500" mr={2}>
                      <FiClock />
                    </Box>
                    <Text fontSize="sm" color="gray.600">Time:</Text>
                  </Flex>
                  <Text fontSize="sm" fontWeight="semibold">{data.scheduletime}</Text>
                </Flex>
                {data?.delivery_partner_name && (
                  <Flex justify="space-between" align="center" bg="whiteAlpha.500" p={2} borderRadius="md">
                    <Text fontSize="sm" color="gray.600">Driver:</Text>
                    <Text fontSize="sm" fontWeight="semibold">{data.delivery_partner_name}</Text>
                  </Flex>
                )}
              </SimpleGrid>
            </Card>
          )} */}

          {/* Row 4: Documents Section */}
          {((type !== "2" && data?.challans?.length > 0) || (type === "4" && data?.orderid && data?.userid?.length > 0)) && (
            <Box>
              <Flex align="center" mb={4}>
                <Box fontSize="xl" color="purple.500" mr={3}>
                  <MdDescription />
                </Box>
                <Heading fontSize="lg" color={headingColor} fontWeight="semibold">
                  Documents
                </Heading>
              </Flex>

              <SimpleGrid columns={[1, 1, 2, 3]} spacing={4}>
                {/* Delivery Challan */}
                {type !== "2" && data?.challans?.length > 0 && (
                  <>
                    {data?.challans?.map((val, ind) => {
                      const matchingDetail = data?.details?.find((detail) => detail.ref_id === val.ref_id);

                      return (
                        <Card
                          key={ind}
                          p={5}
                          borderRadius="xl"
                          boxShadow="sm"
                          border="1px solid"
                          borderColor={borderColor}
                          bg={cardBg}
                        >
                          <Flex align="center" mb={4}>
                            <Box fontSize="2xl" color="orange.500" mr={3}>📋</Box>
                            <Heading fontSize="md">Delivery Challan</Heading>
                          </Flex>

                          <Stack spacing={3} mb={4}>
                            <Flex justify="space-between" align="center" bg="gray.50" p={2} borderRadius="md">
                              <Text fontSize="sm" color="gray.600">DC Number</Text>
                              <Text fontSize="md" fontWeight="bold" color="orange.600">{val.dc_no}</Text>
                            </Flex>

                            <Flex justify="space-between" align="center" bg="gray.50" p={2} borderRadius="md">
                              <Text fontSize="sm" color="gray.600">DC Date</Text>
                              <Text fontSize="md" fontWeight="bold">{val.dc_date}</Text>
                            </Flex>
                          </Stack>

                          <Button
                            colorScheme="orange"
                            size="md"
                            w="full"
                            onClick={() => {
                              downloadDCPdf(data?.userid, data?.orderid, matchingDetail?.id, val.dc_no);
                            }}
                            leftIcon={<MdDescription />}
                          >
                            Download Delivery Challan
                          </Button>
                        </Card>
                      );
                    })}
                  </>
                )}

                {/* Invoice Details */}
                {type === "4" && data?.orderid && data?.userid?.length > 0 && (
                  <Card
                    p={5}
                    borderRadius="xl"
                    boxShadow="sm"
                    border="1px solid"
                    borderColor={borderColor}
                    bg={cardBg}
                  >
                    <Flex align="center" mb={4}>
                      <Box fontSize="2xl" color="purple.500" mr={3}>📄</Box>
                      <Heading fontSize="md">Invoice</Heading>
                    </Flex>

                    <Stack spacing={3} mb={4}>
                      <Flex justify="space-between" align="center" bg="gray.50" p={2} borderRadius="md">
                        <Text fontSize="sm" color="gray.600">Invoice Number</Text>
                        <Text fontSize="md" fontWeight="bold" color="purple.600">{data.inv_no || "NA"}</Text>
                      </Flex>

                      <Flex justify="space-between" align="center" bg="gray.50" p={2} borderRadius="md">
                        <Text fontSize="sm" color="gray.600">Invoice Date</Text>
                        <Text fontSize="md" fontWeight="bold">
                          {data.inv_date !== "0000-00-00 00:00:00"
                            ? new Date(data.inv_date).toLocaleString("en-IN", {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            })
                            : "NA"}
                        </Text>
                      </Flex>
                    </Stack>

                    {isInvoiceAvailable && (
                      <Button
                        colorScheme="purple"
                        size="md"
                        w="full"
                        onClick={downloadInvoicePDF}
                        leftIcon={<MdReceipt />}
                      >
                        Download Invoice
                      </Button>
                    )}
                  </Card>
                )}
              </SimpleGrid>
            </Box>
          )}

          {/* Row 5: Products Section */}
          {data?.details?.length > 0 && (
            <Box>
              <Flex align="center" mb={6}>
                <Heading fontSize="xl" color={headingColor} fontWeight="semibold">
                  Order Products
                </Heading>
                <Badge colorScheme="blue" ml={3} px={2} py={1} borderRadius="full">
                  {data.details.length} {data.details.length === 1 ? 'Item' : 'Items'}
                </Badge>
              </Flex>
              <SimpleGrid
                spacing={4}
                columns={data?.details?.length > 1 ? [1, 2, 3] : 1}
              >
                {data?.details?.map((el) => (
                 <DetailProductCard
                 key={el.id}
                 el={{
                   ...el,
                   scheduledate: data.scheduledate,
                   scheduletime: data.scheduletime,
                 }}
                 type={type}    // <-- PASS TYPE HERE
                 createCustomerCardData={getCustomerCardData}
                 expanded={expanded}
                 setExpanded={setExpanded}
               />
               
                ))}
              </SimpleGrid>
            </Box>
          )}
        </VStack>
      )}

      {/* Enhanced Assign Order Modal */}
      <Modal isOpen={isOpenAsign} onClose={onCloseAsign} isCentered size="xl">
        <ModalOverlay bg="blackAlpha.600" />
        <ModalContent borderRadius="2xl">
          <ModalHeader
            borderBottom="1px solid"
            borderColor={borderColor}
            bg={cardBg}
            borderTopRadius="2xl"
          >
            <Flex align="center">
              <Box fontSize="xl" color="blue.500" mr={3}>
                <MdLocalShipping />
              </Box>
              <Heading fontSize="lg">Assign Delivery Partner</Heading>
            </Flex>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody py={6}>
            <Flex flexDirection="column" gap={4} w="full">
              <FormControl display="flex" flexDirection="column" gap={4}>

                {/* Delivery Partner Selection */}
                <Box>
                  <FormLabel mb={2} fontWeight="semibold" color={headingColor}>
                    Select Delivery Partner
                  </FormLabel>
                  <Select
                    value={udpateAsingData.dplist || ""}
                    onChange={(e) =>
                      setUdpateAsingData({
                        ...udpateAsingData,
                        dplist: e.target.value,
                        dplist_error: "",
                      })
                    }
                    placeholder="Choose delivery partner"
                    size="md"
                    w="full"
                    borderColor={udpateAsingData.dplist_error ? "red.300" : borderColor}
                    _focus={{ borderColor: "blue.500", boxShadow: "0 0 0 1px blue.500" }}
                  >
                    {dp_list?.map((item) => (
                      <option key={item?.id} value={item?.id}>
                        {item?.name}
                      </option>
                    ))}
                  </Select>
                  {udpateAsingData.dplist_error && (
                    <Text color="red.500" fontSize="sm" mt={1} display="flex" alignItems="center">
                      ⚠️ {udpateAsingData.dplist_error}
                    </Text>
                  )}
                </Box>

                {/* Vehicle Selection */}
                <Box>
                  <FormLabel mb={2} fontWeight="semibold" color={headingColor}>
                    Select Vehicle
                  </FormLabel>
                  <Select
                    value={udpateAsingData.vehicle || ""}
                    onChange={(e) =>
                      setUdpateAsingData({
                        ...udpateAsingData,
                        vehicle: e.target.value,
                        vehicle_error: "",
                      })
                    }
                    placeholder="Select vehicle"
                    size="md"
                    w="full"
                    disabled={!udpateAsingData.dplist}
                    borderColor={udpateAsingData.vehicle_error ? "red.300" : borderColor}
                    _focus={{ borderColor: "blue.500", boxShadow: "0 0 0 1px blue.500" }}
                  >
                    {vehicle_loading ? (
                      <option disabled>Loading vehicles...</option>
                    ) : (
                      dp_vehicle_list?.map((item) => (
                        <option key={item.vehicle_id} value={item.vehicle_id}>
                          {item.vehicleno}
                        </option>
                      ))
                    )}
                  </Select>
                  {vehicle_loading && (
                    <Flex align="center" gap={2} mt={2}>
                      <Spinner size="sm" color="blue.500" />
                      <Text fontSize="sm" color={textColor}>Loading available vehicles...</Text>
                    </Flex>
                  )}
                  {udpateAsingData.vehicle_error && (
                    <Text color="red.500" fontSize="sm" mt={1} display="flex" alignItems="center">
                      ⚠️ {udpateAsingData.vehicle_error}
                    </Text>
                  )}
                </Box>

                {/* Driver Selection */}
                <Box>
                  <FormLabel mb={2} fontWeight="semibold" color={headingColor}>
                    Select Driver
                  </FormLabel>
                  <Select
                    value={udpateAsingData.driver || ""}
                    onChange={(e) =>
                      setUdpateAsingData({
                        ...udpateAsingData,
                        driver: e.target.value,
                        driver_error: "",
                      })
                    }
                    placeholder="Choose driver"
                    size="md"
                    w="full"
                    disabled={!udpateAsingData.vehicle}
                    borderColor={udpateAsingData.driver_error ? "red.300" : borderColor}
                    _focus={{ borderColor: "blue.500", boxShadow: "0 0 0 1px blue.500" }}
                  >
                    {driver_loading ? (
                      <option disabled>Loading drivers...</option>
                    ) : (
                      vehicle_driver_list?.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))
                    )}
                  </Select>
                  {driver_loading && (
                    <Flex align="center" gap={2} mt={2}>
                      <Spinner size="sm" color="blue.500" />
                      <Text fontSize="sm" color={textColor}>Loading available drivers...</Text>
                    </Flex>
                  )}
                  {udpateAsingData.driver_error && (
                    <Text color="red.500" fontSize="sm" mt={1} display="flex" alignItems="center">
                      ⚠️ {udpateAsingData.driver_error}
                    </Text>
                  )}
                </Box>

                {/* Estimated Delivery Date */}
                <Box>
                  <FormLabel mb={2} fontWeight="semibold" color={headingColor}>
                    Scheduled Delivery Time
                  </FormLabel>
                  <Input
                    value={data?.scheduletime || ""}
                    isReadOnly
                    size="md"
                    w="full"
                    bg="gray.50"
                    borderColor={borderColor}
                  />
                </Box>

                {unassignedProducts.length > 0 && (
                  <Box>
                    <FormLabel mb={2} fontWeight="semibold" color={headingColor}>
                      Select Products for Delivery
                    </FormLabel>
                    <Card
                      p={4}
                      maxH="200px"
                      overflowY="auto"
                      border="1px solid"
                      borderColor={borderColor}
                      bg={cardBg}
                    >
                      <Stack spacing={3}>
                        {unassignedProducts.map((product) => (
                          <Checkbox
                            key={product.id}
                            isChecked={selectedProducts.includes(product.id)}
                            onChange={(e) => handleProductSelection(product.id, e.target.checked)}
                            colorScheme="blue"
                            size="lg"
                          >
                            <Box>
                              <Text fontWeight="medium">{product.product_name}</Text>
                              <Text fontSize="sm" color={textColor}>
                                Quantity: {product.count} | Price: {formatCurrency(product.price)}
                              </Text>
                            </Box>
                          </Checkbox>
                        ))}
                      </Stack>
                    </Card>
                  </Box>
                )}
                {udpateAsingData.products_error && (
                  <Text color="red.500" fontSize="sm" mt={1} display="flex" alignItems="center">
                    ⚠️ {udpateAsingData.products_error}
                  </Text>
                )}
              </FormControl>
            </Flex>

            {/* Enhanced Customer Information */}
            <Box
              mt={6}
              p={4}
              gap={3}
              flexDirection="column"
              bg={infoCardBg}
              w="full"
              borderRadius="xl"
              border="1px solid"
              borderColor="blue.200"
            >
              <Flex align="center" mb={3}>
                <Box fontSize="lg" color="blue.500" mr={2}>
                  <FiUser />
                </Box>
                <Text fontSize="lg" fontWeight="bold" color="blue.700">
                  Customer Information
                </Text>
              </Flex>
              <CustomerDetailList
                title="Customer Name"
                value={data.customer_name}
              />
              <CustomerDetailList title="Phone Number" value={data.mobile} />
              <CustomerDetailList title="Email" value={data.email} />
              <CustomerDetailList
                title="Shipping Address"
                value={data.shipping_address}
              />
              <Box
                p={3}
                bg="white"
                borderRadius="lg"
                w="full"
                flexDirection="column"
                gap={3}
                mt={2}
              >
                <Text fontSize="sm" fontWeight="semibold" color={headingColor} mb={2}>
                  Order Items
                </Text>
                {data?.details?.map((el, i) => (
                  <CustomerDetailList
                    key={i}
                    title={el.product_name}
                    value={`Qty: ${el.count} | ${formatCurrency(el.price)}`}
                    fontWeight=""
                    fontSize={14}
                  />
                ))}
              </Box>
            </Box>
          </ModalBody>

          <ModalFooter
            display="flex"
            w="full"
            gap={3}
            justifyContent="flex-end"
            borderTop="1px solid"
            borderColor={borderColor}
            pt={4}
          >
            <Button
              colorScheme="gray"
              onClick={() => {
                onCloseAsign();
                setUdpateAsingData({});
              }}
              variant="outline"
              size="md"
            >
              Cancel
            </Button>
            <Button
              colorScheme="blue"
              onClick={HandleAsign}
              isLoading={loading}
              size="md"
              px={6}
              leftIcon={<MdLocalShipping />}
            >
              Assign Order
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Image Modals */}
      <ImageModal url={url} onClose={onClose} isOpen={isOpen} />
      <ImageModal
        url={selectedImage}
        isOpen={isImageOpen}
        onClose={() => {
          setIsImageOpen(false);
          setSelectedImage("");
        }}
      />
      <ImageModal
        url={poDocumentUrl}
        isOpen={isPoDocumentOpen}
        onClose={() => {
          setIsPoDocumentOpen(false);
          setPoDocumentUrl("");
        }}
      />
    </>
  );
};

// Enhanced Helper Component for Info Rows
const InfoRow = ({
  label,
  value,
  valueColor = "gray.800",
  valueFontWeight = "medium",
  fontSize = "sm",
  icon
}) => (
  <Flex justify="space-between" align="center" py={1}>
    <Flex align="center" flex="1">
      {icon && <Text mr={2}>{icon}</Text>}
      <Text fontSize={fontSize} color="gray.600" flex="1">{label}</Text>
    </Flex>
    <Text
      fontSize={fontSize}
      color={valueColor}
      fontWeight={valueFontWeight}
      textAlign="right"
      flex="1"
    >
      {value}
    </Text>
  </Flex>
);

const CustomerDetailList = React.memo(
  ({ title, value, fontWeight = "semibold", fontSize = 14 }) => {
    const textColor = useColorModeValue("gray.600", "gray.300");

    return (
      <Flex w="full" justifyContent="space-between" alignItems="flex-start" py={2}>
        <Text fontSize={fontSize} fontWeight={fontWeight} color={textColor} flex="1">
          {title}:
        </Text>
        <Text fontSize={fontSize} textAlign="right" color={textColor} flex="1" maxW="60%">
          {value}
        </Text>
      </Flex>
    );
  }
);

export default OrderDetail;